var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppStoreIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.119,
    height: 65,
    viewBox: "0 0 53.119 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    "data-name": "Group 38",
    transform: "translate(-19.053 -19.803)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M133,253.518c-5.5,9.412-2,23.695,4.075,32.355,3.033,4.33,6.1,8.217,10.311,8.217.079,0,.159,0,.24-.005a12.848,12.848,0,0,0,4.785-1.258,13.245,13.245,0,0,1,5.669-1.326,12.457,12.457,0,0,1,5.395,1.282,11.543,11.543,0,0,0,5.169,1.224c4.738-.087,7.647-4.281,10.214-7.981a35.166,35.166,0,0,0,4.475-9.046l.018-.057a.524.524,0,0,0-.283-.645l-.038-.016a13.427,13.427,0,0,1-8.23-12.276c-.071-7.1,5.49-10.854,6.606-11.535l.052-.033a.52.52,0,0,0,.151-.738A15.438,15.438,0,0,0,169.51,245.2c-.343-.034-.7-.051-1.054-.051a21.3,21.3,0,0,0-7.59,1.871,12.308,12.308,0,0,1-3.635,1.072,12.015,12.015,0,0,1-3.76-1.085,18.42,18.42,0,0,0-6.628-1.662l-.168,0A16.282,16.282,0,0,0,133,253.518",
    transform: "translate(-111.201 -209.287)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M328.385,135.376a15.459,15.459,0,0,0-10.207,5.237c-2.133,2.469-4.216,6.589-3.668,10.741a.557.557,0,0,0,.508.481c.237.018.477.027.717.027a13.081,13.081,0,0,0,9.635-4.942,15.271,15.271,0,0,0,3.59-11.05.558.558,0,0,0-.575-.494",
    transform: "translate(-269.898 -115.573)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreIcon);
export default __webpack_public_path__ + "static/media/AppStoreIcon.ff7bed6c91a79aa5ffb84f1c4de5008e.svg";
export { ForwardRef as ReactComponent };